module.exports = __webpack_public_path__ + "static/media/gaun.f6af6498.ogg";